<template>
  <div>
    <div>
      <Button type="primary" size="small" style="float:left;margin-right:10px;" @click="openModal('extension')">客服明细
      </Button>
      <Button type="primary" size="small" style="float:left;" @click="openModal('channel')">渠道明细</Button>
    </div>

    <div v-if="modalShow">
      <Modal v-model="modalShow" title="合计" @on-cancel="colsoeModal" width="1000">
        <Table :loading="tableLoading" ref="modalTable" class="table-small tableStyle" :columns="aModalTableList"
               :data="tableData" border height="400"></Table>
        <div slot="footer">
          <Button style="text-align: right" type="primary" @click="exportCsv">导出</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
  import {Table} from 'iview'
  import timeUtil from '../../../common/time-util'

  export default {
    name: "render-invite",
    components: {Table},
    props: {
      searchData: {
        type: Object,
      }
    },
    data() {
      return {
        modalShow: false,
        aModalTableList: [
          {
            title: '推广',
            width: 80,
            key: 'groupName',
            ellipsis: true,
            fixed: 'left'
          },
          {
            title: ' ',
            width: 60,
            fixed: 'left',
            render: (h, params) => {
              let row = params.row
              if (row.img) {
                return h('img', {
                  attrs: {
                    src: params.row.img
                  },
                  style: {
                    width: '25px',
                    height: '25px',
                    'border-radius': '50%',
                    position: 'relative',
                    top: '3px',
                  }
                })
              } else {
                let sNameImg = row.groupName.substr(0, 1)
                return h('span', {
                  style: {
                    display: 'inline-block',
                    width: '25px',
                    height: '25px',
                    'border-radius': '50%',
                    background: '#2db7f5',
                    color: '#FFF',
                    'text-align': 'center',
                    'line-height': '25px'
                  }
                }, sNameImg)
              }
            }
          },
          {
            title: '客资量',
            width: 80,
            key: 'clientCount',
            sortable: true
          },
          {
            title: '有效量',
            width: 80,
            key: 'validClientCount',
            sortable: true
          },
          {
            title: '无效量',
            width: 80,
            key: 'invalidClientCount',
            sortable: true
          },
          {
            title: '待定量',
            width: 80,
            key: 'waitClientCount',
            sortable: true
          },
          {
            title: '网转客资量',
            width: 90,
            key: 'netTurnClientCount',
            sortable: true
          },
          {
            title: '入店量',
            width: 80,
            key: 'comeShopClientCount',
            sortable: true
          },
          {
            title: '非周末入店量',
            width: 108,
            key: 'notWeekComeShopClientCount',
            sortable: true
          },
          {
            title: '周末入店量',
            width: 90,
            key: 'weekComeShopClientCount',
            sortable: true
          },
          {
            title: '成交量',
            width: 80,
            key: 'successClientCount',
            sortable: true
          },
          {
            title: '有效率',
            width: 80,
            key: 'validRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.validRate + '%'
              return h('span', str)
            }
          },
          {
            title: '毛客资入店率',
            width: 120,
            key: 'clientComeShopRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.clientComeShopRate + '%'
              return h('span', str)
            }
          },
          {
            title: '有效客资入店率',
            width: 120,
            key: 'validComeShopRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.validComeShopRate + '%'
              return h('span', str)
            }
          },
          {
            title: '毛客资成交率',
            width: 120,
            key: 'clientSuccessRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.clientSuccessRate + '%'
              return h('span', str)
            }
          },
          {
            title: '有效客资成交率',
            width: 120,
            key: 'successValidRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.successValidRate + '%'
              return h('span', str)
            }
          },
          {
            title: '入店成交率',
            width: 120,
            key: 'comeShopSuccessRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.comeShopSuccessRate + '%'
              return h('span', str)
            }
          },
          {
            title: '非周末入店占比',
            width: 114,
            key: 'notWeekComeShopRate',
            sortable: true,
            render: (h, params) => {
              let str = params.row.notWeekComeShopRate + '%'
              return h('span', str)
            }
          },
          {
            title: '毛客资成本',
            width: 120,
            key: 'groupClientCost',
            sortable: true,
            render: (h, params) => {
              let str = '¥' + params.row.groupClientCost
              return h('span', str)
            }
          },
          {
            title: '营业额',
            width: 100,
            key: 'sumAmount',
            sortable: true,
            render: (h, params) => {
              let str = '¥' + params.row.sumAmount
              return h('span', str)
            }
          },
          {
            title: '成交均价',
            width: 100,
            key: 'avgAmount',
            sortable: true,
            render: (h, params) => {
              let str = '¥' + params.row.avgAmount
              return h('span', str)
            }
          },
          {
            title: 'ROI',
            width: 100,
            key: 'roi',
            sortable: true,
          }
        ],
        tableData: [],
        tableLoading: false,
      }
    },
    methods: {
      openModal(status) {
        this.tableLoading = true
        if (status === 'extension') {
          this.aModalTableList[0].title = '推广'
          this.$http.get('/reports/get_dsyy_group_detail_reports', {
            params: {
              start: this.searchData.start,
              end: this.searchData.end,
              groupId: this.searchData.groupId,
            }
          }).then(data => {
            if (data.code === 100000) {
              this.tableData = data.data
            } else {
              this.$Message.error(data.msg)
            }
          })
        } else if (status === 'channel') {
          this.aModalTableList[0].title = '渠道'
          this.$http.get('/reports/get_dsyy_group_source_reports', {
            params: {
              start: this.searchData.start,
              end: this.searchData.end,
              groupId: this.searchData.groupId,
            }
          }).then(data => {
            if (data.code === 100000) {
              this.tableData = data.data
            } else {
              this.$Message.error(data.msg)
            }
          })
        }
        this.modalShow = true
        this.tableLoading = false
      },

      colsoeModal() {
        this.modalShow = false
      },

      //导出
      exportCsv() {
        let start = timeUtil.getDate(this.searchData.start)
        let end = timeUtil.getDate(this.searchData.end)
        this.$refs.modalTable.exportCsv({
          filename: `${start}${end}合计数据统计`
        });
      }
    }
  }
</script>

<style lang="less">
  .tableStyle {
    th {
      .ivu-table-cell {
        padding: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/plugin/report/render-invite.vue